import {
  entityNumber,
  formatMoney,
  type ModerationEntity,
  type Translate,
} from '@/entities/moderation';

interface PriceRowProps {
  own: ModerationEntity;
  other: ModerationEntity | null | undefined;
  highlight: boolean;
  /** The server lists the price among the request's `changed_fields`. */
  changed?: boolean;
  t: Translate;
}

export function PriceRow({ own, other, highlight, changed = false, t }: PriceRowProps) {
  const ownPrice = entityNumber(own, 'effective_price') ?? entityNumber(own, 'price');
  const otherPrice =
    other == null
      ? undefined
      : (entityNumber(other, 'effective_price') ?? entityNumber(other, 'price'));
  // Always renders (missing reads as `—`) — the reviewer sees every
  // field even when it is unchanged or unfilled.
  return (
    <p className="text-[14px] leading-[normal] tracking-[-0.28px]">
      <span className="font-normal text-[#9ca3af] dark:text-muted-foreground">
        {t('detail.price', 'Цена')}:{' '}
      </span>
      <span
        className={
          highlight && (changed || ownPrice !== otherPrice)
            ? 'font-normal text-destructive'
            : 'font-normal text-foreground'
        }
      >
        {formatMoney(ownPrice)}
      </span>
    </p>
  );
}
